import { MiTHEME } from "@miplatform/theme";
import {
  mdiAccountLockOpen,
  mdiArrowULeftTop,
  mdiCalendarCheckOutline,
  mdiCalendarMonthOutline,
  mdiCalendarRemove,
  mdiCalendarStart,
  mdiCancel,
  mdiCarBack,
  mdiCarEstate,
  mdiCheck,
  mdiCodeBrackets,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiEmailOutline,
  mdiFileDocumentOutline,
  mdiHandFrontLeftOutline,
  mdiInvoiceEditOutline,
  mdiListStatus,
  mdiLockOpenOutline,
  mdiLockOutline,
  mdiPencil,
  mdiProgressClock,
  mdiTagOutline,
} from "@mdi/js";

export const ACTIVITY_STATUSES = {
  NOTE: "Note",
  FOLLOW_UP: "FollowUp",
  STATUS_CHANGE: "StatusChange",
  HOLD_PLACED: "HoldPlaced",
  HOLD_REMOVED: "HoldRemoved",
  CREATED: "Created",
  UNSCHEDULED: "Unscheduled",
  SCHEDULED: "Scheduled",
  RESCHEDULED: "Rescheduled",
  UNLOCKED: "Unlocked",
  LOCKED: "Locked",
  CANCELLED: "Cancelled",
  ORDER_CREATED: "OrderCreated",
  STARTED: "Started",
  STOPPED: "Stopped",
  ENROUTE: "Enroute",
  SUBMITTED: "Submitted",
  FORCE_CLOSEOUT: "ForceCloseout",
  CLOSEOUT_IN_PROGRESS: "CloseoutInProgress",
  CLOSED: "Closed",
  ISSUE_UPDATED: "Issue Updated",
  FAILED: "Failed",
  PASSED: "Passed",
  UNDO_ORDER_ACTION: "UndoOrderAction",
  ACCOUNT_CHANGED: "AccountChanged",
};

export const ACTIVITY_CARD_CONFIG = {
  Created: {
    id: "created",
    title: "Order Created",
    icon: mdiCogOutline,
  },
  EmailNotification: {
    id: "note",
    title: "Email Notification",
    icon: mdiEmailOutline,
  },
  Note: {
    id: "note",
    title: "Note",
    icon: mdiFileDocumentOutline,
  },
  FollowUp: {
    id: "follow_up",
    title: "Follow-Up",
    icon: mdiFileDocumentOutline,
  },
  Scheduled: {
    id: "scheduled",
    title: "Scheduled",
    icon: mdiCalendarMonthOutline,
  },
  Started: {
    id: "started",
    title: "Started",
    icon: mdiProgressClock,
  },
  Stopped: {
    id: "stopped",
    title: "Closed",
    icon: mdiProgressClock,
  },
  Submitted: {
    id: "submitted",
    title: "Submitted",
    icon: mdiCheck,
  },
  Dispatch: {
    id: "dispatch",
    title: "Dispatch",
    icon: mdiCarEstate,
  },
  Confirmed: {
    id: "confirmed",
    title: "Confirmed",
    icon: mdiCalendarCheckOutline,
  },
  Unscheduled: {
    id: "unscheduled",
    title: "Unscheduled",
    icon: mdiCalendarRemove,
  },
  ForceCloseout: {
    id: "force_closeout",
    title: "Force Closeout",
    icon: mdiListStatus,
  },
  CloseoutInProgress: {
    id: "closeout_in_progress",
    title: "Closeout In Progress",
    icon: mdiListStatus,
  },
  IssueUpdated: {
    id: "issue_updated",
    title: "Task Updated",
    icon: mdiPencil,
  },
  OrderDetailsUpdated: {
    id: "order_details_updated",
    title: "Order Details Updated",
    icon: mdiPencil,
  },
  Closed: {
    id: "closed",
    title: "Closed",
    icon: mdiCheck,
    bgColor: MiTHEME.palette.success.light,
    iconBgColor: MiTHEME.palette.success.main,
  },
  AutoCompleted: {
    id: "auto_completed",
    title: "Auto Completed",
    icon: mdiCheck,
    bgColor: MiTHEME.palette.success.light,
    iconBgColor: MiTHEME.palette.success.main,
  },
  OrderCancel: {
    id: "order_cancel_cancelled",
    title: "Order Cancelled",
    icon: mdiCancel,
    bgColor: MiTHEME.palette.red.light,
    iconBgColor: MiTHEME.palette.red.main,
  },
  OrderCreated: {
    id: "order_created",
    title: "Order Created",
    icon: mdiCheck,
    iconBgColor: MiTHEME.palette.blue.dark,
  },
  OrderApproval: {
    id: "order_approval",
    title: "Order Approved",
    icon: mdiCheck,
    iconBgColor: MiTHEME.palette.blue.dark,
  },
  Cancelled: {
    id: "cancel_cancelled",
    title: "Order Cancelled",
    icon: mdiCancel,
    bgColor: MiTHEME.palette.red.light,
    iconBgColor: MiTHEME.palette.red.main,
  },
  [ACTIVITY_STATUSES.UNDO_ORDER_ACTION]: {
    id: "undo_order_action",
    title: "Undo Order Action",
    icon: mdiArrowULeftTop,
  },
  Locked: {
    id: "locked",
    title: "Locked",
    icon: mdiLockOutline,
  },
  Unlocked: {
    id: "unlocked",
    title: "Unlocked",
    icon: mdiLockOpenOutline,
  },
  OrderReschedule: {
    id: "order_reschedule",
    title: "Order Rescheduled",
    icon: mdiCalendarStart,
  },
  HoldPlaced: {
    id: "hold_placed",
    title: "Hold Placed",
    icon: mdiHandFrontLeftOutline,
    iconBgColor: MiTHEME.palette.deepPurple.darkAccent,
  },
  HoldRemoved: {
    id: "hold_removed",
    title: "Hold Removed",
    icon: mdiHandFrontLeftOutline,
    iconBgColor: MiTHEME.palette.deepPurple.darkAccent,
  },
  OrderHoldFollowUp: {
    id: "order_hold_follow_up",
    title: "Hold Follow-Up",
    icon: mdiHandFrontLeftOutline,
    iconBgColor: MiTHEME.palette.deepPurple.darkAccent,
  },
  Enroute: {
    id: "enroute",
    title: "Enroute",
    icon: mdiCarBack,
  },
  OrderHold: {
    id: "order_hold",
    title: "Hold Placed",
    icon: mdiHandFrontLeftOutline,
    iconBgColor: MiTHEME.palette.deepPurple.darkAccent,
  },
  ScheduleOverCapacity: {
    id: "schedule_over_capacity",
    title: "Schedule Over Capacity",
    icon: mdiCalendarStart,
  },
  ScheduleOutOfRange: {
    id: "schedule_out_of_range",
    title: "Schedule Out Of Range",
    icon: mdiCalendarRemove,
  },
  RescheduleOutOfRange: {
    id: "reschedule_out_of_range",
    title: "Reschedule Out Of Range",
    icon: mdiCalendarRemove,
  },
  ManagerApprovalOrderHold: {
    id: "manager_approval_order_hold",
    title: "Manager Approval Order Hold",
    icon: mdiAccountLockOpen,
  },
  ForceCompleteOrderForAccounting: {
    id: "force_closeout_accounting",
    title: "Force Closeout For Accounting",
    icon: mdiCodeBrackets,
  },
  ManagerApprovalForceCompleteOrder: {
    id: "manager_approval_force_complete",
    title: "Manager Approval Force Complete Order",
    icon: mdiAccountLockOpen,
  },
  ManagerApprovalForceCompleteOrderForAccounting: {
    id: "manager_approval_force_complete_for_accounting",
    title: "Manager Approval Force Complete Order For Accounting",
    icon: mdiAccountLockOpen,
  },
  ForceCompleteOrder: {
    id: "force_complete",
    title: "Force Complete",
    icon: mdiCheck,
  },
  ManagerApprovalExcludeSync: {
    id: "manager_approval_exclude_sync",
    title: "Manager Approval Exclude Sync",
    icon: mdiAccountLockOpen,
  },
  ManagerApprovalInvoiceNotToday: {
    id: "manager_approval_invoice_not_today",
    title: "Manager Approval Invoice Not Today",
    icon: mdiAccountLockOpen,
  },
  CreateVariances: {
    id: "create_variances",
    title: "Create Variances",
    icon: mdiCodeBrackets,
  },
  InvoicingComplete: {
    id: "invoicing_complete",
    title: "Invoicing Complete",
    icon: mdiCheck,
    bgColor: MiTHEME.palette.success.light,
    iconBgColor: MiTHEME.palette.success.main,
  },
  InvoiceVoided: {
    id: "invoice_voided",
    title: "Invoice Voided",
    icon: mdiCancel,
    bgColor: MiTHEME.palette.red.light,
    iconBgColor: MiTHEME.palette.red.main,
  },
  PreBillComplete: {
    id: "pre_bill_complete",
    title: "Pre-Bill Complete",
    icon: mdiCheck,
  },
  PendingPrebill: {
    id: "pending_pre_bill",
    title: "Pending Pre-Bill",
    icon: mdiInvoiceEditOutline,
  },
  PendingInvoicing: {
    id: "pending_invoicing",
    title: "Pending Invoicing",
    icon: mdiInvoiceEditOutline,
  },
  BillingCommitmentAttached: {
    id: "billing_commitment_attached",
    title: "Billing Commitment Attached",
    icon: mdiCheck,
  },
  BillingCommitmentDetached: {
    id: "billing_commitment_detached",
    title: "Billing Commitment Detached",
    icon: mdiCheck,
  },
  CategoryDropCreated: {
    id: "category_drop_created",
    title: "Category Drop Created",
    icon: mdiCurrencyUsd,
  },
  CategoryDropDeleted: {
    id: "category_drop_deleted",
    title: "Category Drop Deleted",
    icon: mdiCurrencyUsd,
  },
  PriceLevelAssigned: {
    id: "price_level_assigned",
    title: "Price Level Assigned",
    icon: mdiCurrencyUsd,
  },
  PriceLevelUnassigned: {
    id: "price_level_unassigned",
    title: "Price Level Unassigned",
    icon: mdiCurrencyUsd,
  },
  PriceLevelCreated: {
    id: "price_level_created",
    title: "Price Level Created",
    icon: mdiCurrencyUsd,
  },
  PriceLevelUpdated: {
    id: "price_level_updated",
    title: "Price Level Updated",
    icon: mdiCurrencyUsd,
  },
  PriceLevelDeleted: {
    id: "price_level_deleted",
    title: "Price Level Deleted",
    icon: mdiCurrencyUsd,
  },
  PriceLevelDuplicated: {
    id: "price_level_duplicated",
    title: "Price Level Duplicated",
    icon: mdiCurrencyUsd,
  },
  PriceLevelDeactivated: {
    id: "price_level_deactivated",
    title: "Price Level Deactivated",
    icon: mdiCurrencyUsd,
  },
  PriceLevelReactivated: {
    id: "price_level_reactivated",
    title: "Price Level Reactivated",
    icon: mdiCurrencyUsd,
  },
  PriceLevelsReordered: {
    id: "price_levels_reordered",
    title: "Price Levels Reordered",
    icon: mdiCurrencyUsd,
  },
  JobComplete: {
    id: "job_complete",
    title: "Completed",
    icon: mdiCheck,
    bgColor: MiTHEME.palette.success.light,
    iconBgColor: MiTHEME.palette.success.main,
  },
  JobIncomplete: {
    id: "job_incomplete",
    title: "Incomplete",
    icon: mdiCancel,
    bgColor: MiTHEME.palette.red.light,
    iconBgColor: MiTHEME.palette.red.main,
  },
  // INSPECTION ACTIVITIES
  [ACTIVITY_STATUSES.FAILED]: {
    id: "failed",
    title: "Failed",
    icon: mdiTagOutline,
    iconBgColor: MiTHEME.palette.error.main,
  },
  [ACTIVITY_STATUSES.PASSED]: {
    id: "passed",
    title: "Passed",
    icon: mdiTagOutline,
    iconBgColor: MiTHEME.palette.success.main,
  },
  [ACTIVITY_STATUSES.ACCOUNT_CHANGED]: {
    id: "account_changed",
    title: "Account Changed",
    icon: mdiInvoiceEditOutline,
    iconBgColor: MiTHEME.palette.info.main,
  },
};
